import React, {useEffect, useState} from 'react';
import {Box, Chip, TextField, Typography, IconButton, MenuItem, Select} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {useDispatch, useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Search } from '@material-ui/icons';
import { useToken } from '../../../utilities/hooks';
import DateRangePicker from '../DateTimeRangePicker';

const useStyles = makeStyles((theme) => ({
    gridStyle: {
        paddingBottom: 12, 
        marginTop: theme.spacing(1)
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(3),
        flexWrap: 'wrap',
        alignItems: 'center'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    dateSelectBetween : {
        alignSelf: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    quickAction: {
        '& > *': {
            margin: theme.spacing(1),
          },
    },
    title: {
        marginBottom: theme.spacing(1)
    },
    dateRangeRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        alignItems: 'center'
    }
}));

export default function DateRangeSearch(props) {
    const classes = useStyles();
    const {t} = useTranslation('secondDelivery');

    const {onSearchClick, branches, userCity} = props

    const tokenContents = useToken();
    const authBranches = tokenContents.warehouse;

    const [dateFrom, setDateFrom] = useState(moment());
    const [dateTo, setDateTo] = useState(moment());
    const [branch, setBranch] = useState(userCity);

    const handleWarehouseChange = (event) => {
        setBranch(event.target.value);
    }

    const handleToday = () => {
        setDateFrom(moment());
        setDateTo(moment());
    };

    const handle3Days = () => {
        setDateFrom(moment().subtract(2, 'd'));
        setDateTo(moment());
    };

    const handle7Days = () => {
        setDateFrom(moment().subtract(6, 'd'));
        setDateTo(moment());
    };

    const handle1Month = () => {
        setDateFrom(moment().subtract(1, 'months'));
        setDateTo(moment());
    };

    const handleDateChange = (event) => {
        console.log(event.target.id)
        if(event.target.id === 'from'){
            setDateFrom(moment(event.target.value))
        } else if(event.target.id === 'to'){
            setDateTo(moment(event.target.value))
        }
    }

    return (
        <Box>
            <div>
                <Typography className={classes.title}>{t('order_date')}</Typography>
            </div>
            <Box>
                <form className={classes.container} noValidate>
                    <DateRangePicker
                        className={classes.dateRangeRow}
                        fromDateValue={dateFrom}
                        toDateValue={dateTo}
                        textFieldStyle={{
                            minWidth: 236,
                            flex: 1
                        }}
                        handleDateChange={handleDateChange}
                    />
                    <TextField
                        select
                        className={classes.textField}
                        value={branch}
                        displayEmpty
                        variant="outlined"
                        onChange={handleWarehouseChange}
                    >
                    {
                        branches &&
                        branches.filter((branch) => (authBranches.includes(branch.id)))
                        .map((branch) => (
                            <MenuItem key={branch.id} value={branch.id}>
                                {branch.name}
                            </MenuItem>
                        ))
                    }
                    </TextField>
                    <IconButton color='primary' onClick={() => onSearchClick(dateFrom, dateTo, branch)}>
                        <Search />
                    </IconButton>
                </form>
            </Box>
            <div className={classes.quickAction}>
                <Chip
                    label={t('today')}
                    color="primary"
                    variant='outlined'
                    onClick={handleToday}
                />
                <Chip
                    label={t('last_three_days')}
                    color="primary"
                    variant='outlined'
                    onClick={handle3Days}
                />
                <Chip
                    label={t('last_seven_days')}
                    color="primary"
                    variant='outlined'
                    onClick={handle7Days}
                />
                <Chip
                    label={t('last_month')}
                    color="primary"
                    variant='outlined'
                    onClick={handle1Month}
                />
            </div>
        </Box>
    );
}

DateRangeSearch.defaultProps = {
    onSearchClick: ()=>{}
}